import api, {publicApi} from 'services/api'
import {pageSize} from 'constatnts'

const BASE_URI = ''

const filterDate = date => `&createdMoreThanOrEqual=${date[0].format('YYYY-MM-DD hh:mm:ss')}&createdLessThanOrEqual=${date[1].format('YYYY-MM-DD hh:mm:ss')}`

export const usersService = {
  authEmail: data =>
    publicApi.post(`${BASE_URI}/auth/email`, data, true),
  authRefresh: data =>
    publicApi.post(`${BASE_URI}/auth/refreshToken`, data, true),
  users: data =>
    publicApi.post(`${BASE_URI}/users`, data, true),
  usersEdit: (data, uuid, t) =>
    api(t).patch(`${BASE_URI}/users/${uuid}`, data, true),
}

export const accountantService = {
  getCustomers: (uuid, t, page) =>
    api(t).get(`${BASE_URI}/accountant/${uuid}/customers?skip=${page * pageSize}`),
  getCustomerInvoices: (uuid, uuidCustomers, t, page, filter) =>
    api(t).get(
      `${BASE_URI}/accountant/${uuid}/customers/${uuidCustomers}/invoices?skip=${page * pageSize}`
      + `${filter?.date ? filterDate(filter.date) : ''}`
    ),
}

export const invitesService = {
  getInvites: (uuid, t, page) =>
    api(t).get(`${BASE_URI}/accountant/${uuid}/invites?skip=${page * pageSize}`),
  patchInvites: (uuid, uuidInvite, data, t) =>
    api(t).patch(`${BASE_URI}/accountant/${uuid}/invites/${uuidInvite}`, data, true),
}

export default [usersService, accountantService, invitesService]
